import type { ComposedInvoice, PartnerInvoice } from 'src/interfaces/invoice'

/**
 * The human-facing id when the backend has one, else the uuid. `invoiceId` is nullable on both
 * DTOs and is empty until the invoice document is generated, so the fallback is not optional.
 */
export const getPartnerInvoiceLabel = (invoice: PartnerInvoice): string => {
  if (invoice.invoiceId !== null && invoice.invoiceId !== undefined && invoice.invoiceId !== '') {
    return invoice.invoiceId
  }

  return invoice.id
}

export const getComposedInvoiceLabel = (invoice: ComposedInvoice): string => {
  if (invoice.invoiceId !== null && invoice.invoiceId !== undefined && invoice.invoiceId !== '') {
    return invoice.invoiceId
  }

  return invoice.id
}

/**
 * `invoiceId → label`, handed to the batch saga on the action payload. The saga receives only
 * ids, and a results list of bare uuids is unreadable, so the labels travel with the request.
 */
export const buildInvoiceLabels = (invoices: PartnerInvoice[]): Record<string, string> => {
  return invoices.reduce<Record<string, string>>((accumulator, invoice) => {
    accumulator[invoice.id] = getPartnerInvoiceLabel(invoice)

    return accumulator
  }, {})
}
